export default "__VITE_ASSET__c4b43680__"